import { CanActivateFn } from '@angular/router';

export const publicGuard: CanActivateFn = (): boolean => {
  // Siempre permite el acceso a rutas públicas
  return true;
};


